import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Container, Col, Row } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import SongItem from '../../Shared/SongItem/SongItem'
import { setSelectedSong, setShowDownloadSongPopUp, setSelectedCategory, goToPage , reportAnalytics} from '../../fundialSlice';
import DownloadSongPopUp from '../DownloadSongPopUp/DownloadSongPopUp'
import CategoryItem from '../CategoryItem/CategoryItem'


const Gallery = (props) => {
    const [galleryList, setGalleryList] = useState(props.items);

    useEffect(() => {
        if(props.items && props.isCategories){
            setGalleryList([...props.items].reverse());
        }
        else if(props.items && props.items.length >= 19){
            setGalleryList(props.items.slice(0, 19))
        }
      }, []);

    function openDownloadPopUp(item) {
        if(props.currentPage == "lobbyPage"){
            props.reportAnalytics({
                eventCategory: 'fundial',
                eventAction: "HN_Lobby_ChooseSongButton",
                eventLabel: "",
              });
        }
        props.reportAnalytics({
            eventCategory: 'fundial',
            eventAction: "HN_PopUp_Reveald",
            eventLabel: "",
          });

        props.setSelectedSong(item);
        props.setShowDownloadSongPopUp(true);
    }

    function goToAllSongsPage(){
        props.setSelectedCategory({id: props.categoryId, title: props.title, page: "songListPage" });
        props.goToPage({page: 'songListPage'});
    }

    function onSlideChange(){
        if(props.currentPage == "lobbyPage"){
            props.reportAnalytics({
                eventCategory: 'fundial',
                eventAction: "HN_Lobby_ScrollContent",
                eventLabel: "",
              });
        }
    }

    return (

        <div className='fundial-gallery'>
            {(props.title || props.subTitle) && 
            <>
            <div className="header">
                <Row>
                    {props.title &&  <Col xs={7}><h1>{props.title}</h1></Col>}
                    {props.subTitle && <Col xs={5}><button style={{ float: 'left' }} onClick={() => {goToAllSongsPage()}} className="all-songs-btn" >{props.subTitle}</button></Col>}
                </Row>
            </div>
            <div className="sparator"></div>
            </>
            }
            <div className="swiper-container">
                <Swiper className="swiper-item"
                    spaceBetween={10}
                    slidesPerView='auto'
                    scrollbar={{ draggable: true }}
                    onSwiper={(swiper) => console.log(swiper)}
                    onSlideChange={() => onSlideChange()}>
                    {galleryList.map((item, i) => (
                        <SwiperSlide key={i} className={props.isCategories ? "categories-swiper" : ""}>
                            {props.isCategories ? 
                            <CategoryItem  data={item} onClickCategory={props.onClickCategory} isGalleryMode={true} />
                            :
                            <SongItem onClickSong={() => openDownloadPopUp(item)} isDisplayPlayer={false} playerSize={props.playerSize ? props.playerSize : isMobile ? 87 : 139} isDetailsFromLeft={false} audio={item} />
                            }
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>

    );
};

const mapStateToProps = (state) => {
    return {
        selectedSong: state.fundialPage.selectedSong,
        currentPage : state.fundialPage.navigation.currentPage
    };
};

const mapDispatchToProps = {
    setSelectedSong,
    setShowDownloadSongPopUp, 
    setSelectedCategory, 
    goToPage,
    reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(Gallery);